import { QueryKeys } from '../../utils/queryKeys';

export const postChapterAssessmentKeys = {
    all: [QueryKeys.GET_POST_CHAPTER_QUESTION],
    getPostChapterAssessmentKeys: () => [...postChapterAssessmentKeys.all],
};